import { render, staticRenderFns } from "./resetpass.vue?vue&type=template&id=f7f9f858&"
import script from "./resetpass.vue?vue&type=script&lang=js&"
export * from "./resetpass.vue?vue&type=script&lang=js&"
import style0 from "./resetpass.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports